import { render } from "./general-sidebar.vue?vue&type=template&id=27f03710"
import script from "./general-sidebar.vue?vue&type=script&lang=js"
export * from "./general-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__